import { Swiper, SwiperSlide } from "swiper/react";
import { IBookItem } from "~/utils/interface";
import { Book } from "~/components";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";

import "swiper/css";

interface ISliderBooks {
  books: IBookItem[];
}

const SliderTopReadsBooks = ({ books }: ISliderBooks) => {
  const width = useWindowWidth();

  const mobileView = width < 993;

  return (
    <div>
      {mobileView ? (
        <Swiper
          className="top__read_slider"
          spaceBetween={16}
          slidesPerView={2}
          loop
          breakpoints={{
            320: {
              slidesPerView: "auto",
              centeredSlides: true,
            },
          }}
        >
          {books?.map((book, bookId) => {
            return (
              <SwiperSlide key={`${bookId}_book_slider_${book.book_id}`}>
                <Book
                  book_id={book.book_id}
                  peppers={book.peppers}
                  title={book.title}
                  cover={book.cover}
                  tropes={book.tropes}
                  showTropes={true}
                  showPeppers={true}
                  is_free={book.is_free}
                  className={
                    width < 768 ? "p-2 bg-[#1C3055] rounded-lg" : undefined
                  }
                  imageClasses={
                    width < 768
                      ? "border-[rgba(255,255,255,0.2)] shadow-[1px_4px_11px_rgba(0,0,0,0.25)]"
                      : undefined
                  }
                  pepperClasses={
                    width < 768 ? "flex justify-between w-full py-3" : undefined
                  }
                  imageHeight={344}
                  imageWidth={344}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <div
          className={"grid max-md:grid-cols-1 grid-cols-4 gap-8 max-xl:gap-4"}
          key="Top reads block"
        >
          {books?.map((book, bookId) => {
            return (
              <Book
                key={`${bookId}_book_slider_top_${book.book_id}`}
                book_id={book.book_id}
                peppers={book.peppers}
                title={book.title}
                cover={book.cover}
                tropes={book.tropes}
                showTropes
                showPeppers
                is_free={book.is_free}
                imageWidth={344}
                imageHeight={344}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

SliderTopReadsBooks.displayName = "SliderTopReadsBooks";
export default SliderTopReadsBooks;
